import model from 'modules/group/groupModel';

const { fields } = model;

export default [
  fields.name,
  fields.ebox,
];
